export function getdata() {
	var obj = {
		rules: {
			test1: [{
				required: true,
				message: '请填写公司代码',
				trigger: 'blur'
			}],
			test2: [{
				required: true,
				message: '请选择是否为报税主体',
				trigger: 'blur'
			}],
			test3: [{
				required: true,
				message: '请填写纳税人识别号',
				trigger: 'blur'
			}],
			test4: [{
				required: true,
				message: '请选择是否启用',
				trigger: 'blur'
			}],
			test5: [{
				required: true,
				message: '请填写纳税人(公司)名称',
				trigger: 'blur'
			}],
			test7: [{
				required: true,
				message: '请选择所属行业',
				trigger: 'blur'
			}]
		},
		headtitle: [{
				label: "基础信息"
			},
			{
				label: "报税登录"
			},
			{
				label: "申报内容"
			}
		],
		XYheadData: [{
				title: "三方协议号",
				prop: "protocolNumber",
				width: 120,
			},
			{
					title: "是否默认",
					prop: "isDefault",
					width: 120,
					custom: true
				},
			{
				title: "操作",
				prop: "cz",
				custom: true,
				fixed: "right"
			},
		],
		headData: [{
				title: "公司代码",
				prop: "test1",
				align: "left"
			},
			{
				title: "公司名称",
				prop: "test1",
				align: "left"
			},
			{
				title: "是否启用",
				prop: "test1",
				align: "left"
			},
		],
		formlist: [{
				prop: "test1",
				label: "省市地区代码",
				type: "select",
			},
			{
				prop: "test2",
				label: "登录方式",
				type: "select",
			},
			{
				prop: "test3",
				label: "账号",
				type: "input",
			},
			{
				prop: "test4",
				label: "密码",
				type: "input",
				ispassword: true
			},
			{
				prop: "test5",
				label: "身份类型",
				type: "select",
			},
			{
				prop: "test6",
				label: "证件号码",
				type: "input",
			},
			{
				prop: "test7",
				label: "个人用户名",
				type: "input",
			},
			{
				prop: "test8",
				label: "个人密码",
				type: "input",
				ispassword: true
			},
			{
				prop: "test9",
				label: "办税小号",
				type: "input",
			},
			{
				prop: "test10",
				label: "办税手机号",
				type: "input",
			}
		],
		formdata: {},
        pagination: {
			pageNum: 1,
			pageSize: 10,
			total: 0,
			paginationkey: 0
		},
		protocolNumberFormList:[
		{
		prop: 'protocolNumber',
		label: '三方协议号',
		type: 'input',
		width: '300px',
		isnotnull: true,
		},
		{
		prop: 'isDefault',
		label: '是否默认',
		type: 'radio',
		isnotnull: true,
		
		radioval: [
		{
			label: '是',
			value: '1'
		},
		{
			label: '否',
			value: '0'
		}
	],
		}		
		],
		protocolNumberFormData: {
			id:'',
			protocolNumber:'',
			isDefault:'',
		},
		headDatabody: [{
				title: "申报税种",
				prop: "shuizMc",
				custom: true,
				width: "120px",
			},
			{
				title: "税表选择",
				prop: "test2",
				custom: true,
				width: "100px"
			},
			{
				title: "税表名称",
				prop: "reportName",
				align: "left",
				width: "300px",

			},
			{
				title: "申报周期",
				prop: "shenbzq",
				align: "left",
				custom: true,
				width: "100px",
			},
			{
				title: "是否报送",
				prop: "shifbs",
				align: "left",
				width: "100px",
				custom: true,
			},
			{
				title: "汇总申报",
				prop: "huizsb",
				align: "left",
				custom: true,
				width: "100px"
			},
			{
				title: "操作",
				prop: "test5",
				align: "left",
				custom: true,
				width: "100px"
			},
		],
		tableDatabody: [],
		formlistGeneralx: [{
			prop: "shenbzqDfsljsjj",
			label: "地方水利建设基金",
			type: "input",
			slot: true,
		}, ],
		formdataGeneralx: {
			shenbzqDfsljsjj: ''
		},
		formlistGeneralD: [{
				prop: "shenbzqDfsljsjj",
				label: "地方水利建设基金",
				type: "input",
				slot: true,
			},
			{
				prop: "shenbzqGhjfbw",
				label: "工会经费",
				type: "input",
				slot: true,
			},
			{
				prop: "shenbzqCzljclf",
				label: "城镇垃圾处理费",
				type: "input",
				slot: true,
			},
			{
				prop: "shifbs",
				label: "是否报送",
				type: "radio",
				slot: true
			},
		],
		formdataGeneralD: {
			shenbzqDfsljsjj: '',
			shenbzqGhjfbw: '',
			shenbzqCzljclf: '',
			shifbs: '',
		},
		formlistConstruction: [{
				prop: "shenbzq",
				label: "申报周期",
				type: "input",
				slot: true,
			},
			{
				prop: "shifbs",
				label: "是否报送",
				type: "radio",
				slot: true
			},
			{
				prop: "dfSrbl",
				label: "归属中央收入比例",
				type: "input",
			},
			{
				prop: "zySrbl",
				label: "归属地方收入比例",
				type: "input",
			},
			{
				prop: "dfSrjzbl",
				label: "归属地方收入减征比例",
				type: "input",
			},
		],
		formdataConstruction: {
			shenbzq: '',
			shifbs: '',
			dfSrbl: '',
			zySrbl: '',
			dfSrjzbl: '',
		},
		updatecompanyformlist: [{
				prop: "test1",
				label: "征收方式",
				type: "select",
				width: "220px",
				disabled: true,
				selectval: [{
					label: "查账征收",
					value: "1"
				}],
			},
			{
				prop: "shenbzq",
				label: "申报周期",
				type: "input",
				slot: true,
			},
			{
				prop: "test6",
				label: "是否报送",
				type: "radio",
				slot: true
			},
			{
				prop: "huizsb",
				label: "汇总申报",
				type: "select",
				width: "220px",
				selectval: [{
					label: '无需',
					value: '0'
				}, {
					label: '汇总机构',
					value: '1'
				}, {
					label: '分支机构',
					value: '2'
				}],
				selectchange: true,
			},
			{
				prop: "test8",
				label: "对应汇总机构",
				type: "select",
				slot: true
			},
		],
		updatecompanyformdata: {
			test1: '1',
			test6: "",
			shenbzq: [],
			huizsb: '',
		},
		shenbaodata: [{
				label: "主表"
			},
			{
				label: "附表二"
			},
			{
				label: "居民企业参股外国企业信息报告表"
			},
			{
				label: "附表四"
			},
			{
				label: "企业所得税汇总纳税分支机构所得税分配表"
			}
		],
		headDatayhs: [{
				title: "税目",
				prop: "shuim",
				align: "left",
				custom: true
			},
			{
				title: "子目",
				prop: "zim",
				align: "left",
				custom: true
			},
			{
				title: "申报期限类型",
				prop: "shenbqxlx",
				align: "left",
				custom: true
			},
			{
				title: "税率",
				prop: "shuil",
				align: "left",
			},
		],
		tableDatayhs: [{
			test1: '',
			option: [],
			test2: '',
			test4: ''
		}],

		headDatahouse: [

			{
				title: "税种",
				prop: "reportName",
				align: "left",
				width: "100px"
			},
			{
				title: "计税依据",
				prop: "jisyj",
				align: "left",
				width: "100px"
			},
			{
				title: "申报周期",
				prop: "shenbzq",
				align: "left",
				custom: true,
				width: "300px"
			},
			{
				title: "是否报送",
				prop: "shifbs",
				align: "left",
				custom: true,
				width: "150px"
			},
		],
		headDatahj: [

			{
				title: "申报内容",
				prop: "reportName",
				align: "left",
				width: "100px"
			},
			{
				title: "申报周期",
				prop: "shenbzq",
				align: "left",
				custom: true,
				width: "300px"
			},
			{
				title: "是否报送",
				prop: "shifbs",
				align: "left",
				custom: true,
				width: "150px"
			},
		],
		headDatacbj: [{
				title: "税种",
				prop: "reportName",
				align: "left",
				width: "100px"
			},
			{
				title: "申报周期",
				prop: "shenbzq",
				align: "left",
				custom: true,
				width: "300px"
			},
			{
				title: "是否报送",
				prop: "shifbs",
				align: "left",
				custom: true,
				width: "150px"
			},
		],
		headDatacty: [{
				title: "税种",
				prop: "reportName",
				align: "left",
				width: "100px"
			},
			{
				title: "申报周期",
				prop: "shenbzq",
				align: "left",
				custom: true,
				width: "300px"
			},
			{
				title: "是否报送",
				prop: "shifbs",
				align: "left",
				custom: true,
				width: "150px"
			},
		],
		tableDataty: [{
			shifbs: 1,
			reportName: '残保金'
		}],
		tableDatacb: [{
			shifbs: 1,
			reportName: '残保金'
		}],
		headDatacw: [{
				title: "是否填写",
				prop: "test1",
				align: "left",
				width: "100px",
				custom: true
			},
			{
				title: "报表名称",
				prop: "reportName",
				align: "left",
				width: "200px"
			},
			{
				title: "申报周期",
				prop: "shenbzq",
				align: "left",
				custom: true,
				width: "300px"

			}
		],
		tableDatacw: [{},
			{}
		],
		headDatahz: [{
				title: "选择",
				prop: "test1",
				custom: true,
				width: "40px"
			},
			{
				title: "公司代码",
				prop: "companyCode",
				align: "left",
				width: "100px"
			},
			{
				title: "公司名称",
				prop: "nsrmc",
				align: "left",
				width: "200px"
			}
		],
		formlistjz: [{
				prop: "shifzzsxgmnsr",
				label: "是否增值税小规模纳税人",
				type: "radio",
				radioval: [{
						label: "是",
						value: "Y"
					},
					{
						label: "否",
						value: "N"
					},
				],
			},
			{
				prop: "benqsfsyxwqy",
				label: "本期是否适用小微企业“六税两费”减免政策",
				type: "radio",
				radioval: [{
						label: "是",
						value: "Y"
					},
					{
						label: "否",
						value: "N"
					},
				],
			},
			{
				prop: "jianmzcsyzt",
				slot: true,
				label: "",
			}

		],
		tableDataxfs: [{
			pm: '',
			option: [],
			zm: '',
			shuil: ''
		}],
		optionxfs: [{
				label: "烟",
				value: "101020100",
				children: [{
						label: "卷烟（调拨价70元（不含增值税）/条以上（含70元），从价计算）",
						value: "101020101",
						type: "1",
						shuil: "0.56"

					},
					{
						label: "卷烟（调拨价70元（不含增值税）/条以下，从价计算）",
						value: "101020102",
						type: "1",
						shuil: "0.36"
					},
					{
						label: "卷烟（调拨价70元（不含增值税）/条以上（含70元），从量计算）",
						value: "101020104",
						type: "2",
						shuil: "30"
					},
					{
						label: "卷烟（调拨价70元（不含增值税）/条以下，从量计算）",
						value: "101020105",
						type: "2",
						shuil: "30"
					},
					{
						label: "卷烟（商业批发，从价计算）",
						value: "101020106",
						type: "1",
						shuil: "0.11"
					},
					{
						label: "雪茄烟",
						value: "101020107",
						type: "1",
						shuil: "0.36"
					},
					{
						label: "烟丝",
						value: "101020108",
						type: "1",
						shuil: "0.30"
					},
					{
						label: "卷烟（商业批发，从量计算）",
						value: "101020109",
						type: "2",
						shuil: "50"
					},
					{
						label: "电子烟（生产环节，从价计征）",
						value: "101020110",
						disabled: true
					},
					{
						label: "电子烟（批发环节，从价计征）",
						value: "101020111",
						disabled: true
					},
				]
			},
			{
				label: "酒",
				value: "101020200",
				children: [{
						label: "粮食白酒（从价计算）",
						value: "101020201",
						type: "1",
						shuil: "0.20"
					},
					{
						label: "粮食白酒（从量计算）",
						value: "101020202",
						type: "2",
						shuil: "0.5"
					},
					{
						label: "薯类白酒（从价计算）",
						value: "101020203",
						type: "1",
						shuil: "0.20"
					},
					{
						label: "薯类白酒（从量计算）",
						value: "101020204",
						type: "2",
						shuil: "0.5"
					},
					{
						label: "黄酒",
						value: "101020205",
						type: "2",
						shuil: "240"
					},
					{
						label: "啤酒（3000元/吨以上）",
						value: "101020206",
						type: "2",
						shuil: "250"
					},
					{
						label: "啤酒（3000元/吨以下）",
						value: "101020207",
						type: "2",
						shuil: "220"
					},
					{
						label: "酒精",
						value: "101020208",
						disabled: true
					},
					{
						label: "其他酒",
						value: "101020299",
						type: "1",
						shuil: "0.10"
					},

				]
			},
			{
				label: "化妆品",
				value: "101020300",
				disabled: true
			},
			{
				label: "首饰和珠宝玉石",
				value: "101020400",
				children: [{
						label: "金银首饰（铂金首饰、钻石及钻石饰品）",
						value: "101020401",
						type: "1",
						shuil: "0.05"
					},
					{
						label: "其他金银首饰及珠宝玉石",
						value: "101020499",
						type: "1",
						shuil: "0.10"
					},
				]
			},
			{
				label: "鞭炮、焰火",
				value: "101020500",
				type: "1",
				shuil: "0.15"
			},
			{
				label: "成品油",
				value: "101020600",
				children: [{
						label: "含铅汽油",
						value: "101020601",
						shuil: "1.52"
					},
					{
						label: "无铅汽油",
						value: "101020602",
						shuil: "1.52"
					},
					{
						label: "柴油",
						value: "101020603",
						type: "2",
						shuil: "1.20"
					},
					{
						label: "航空煤油",
						value: "101020604",
						type: "2",
						shuil: "1.20"
					},
					{
						label: "石脑油",
						value: "101020605",
						type: "2",
						shuil: "1.52"
					},
					{
						label: "溶剂油",
						value: "101020606",
						type: "2",
						shuil: "1.52"
					},
					{
						label: "润滑油",
						value: "101020607",
						type: "2",
						shuil: "1.52"
					},
					{
						label: "燃料油",
						value: "101020608",
						type: "2",
						shuil: "1.20"
					},
					{
						label: "汽油",
						value: "101020609",
						type: "2",
						shuil: "1.52"
					},

				]
			},
			{
				label: "汽车轮胎",
				value: "101020700",
				disabled: true,
				children: [{
						label: "子午线轮胎",
						value: "101020701",
						disabled: true
					},
					{
						label: "斜交胎",
						value: "101020702",
						disabled: true
					},
					{
						label: "内胎",
						value: "101020703",
						disabled: true
					},
					{
						label: "其他汽车轮胎",
						value: "101020799",
						disabled: true
					},

				]
			},
			{
				label: "摩托车",
				value: "101020800",
				children: [{
						label: "250毫升（含）以下的摩托车",
						value: "101020801",
						disabled: true
					},
					{
						label: "250毫升（不含）以上摩托车",
						value: "101020802",
						type: "1",
						shuil: "0.10"
					},
					{
						label: "250毫升摩托车",
						value: "101020803",
						type: "1",
						shuil: "0.03"
					},

				]
			},
			{
				label: "乘用车",
				value: "101020900",
				children: [{
						label: "1.0升（含）以下的乘用车",
						value: "101020901",
						type: "1",
						shuil: "0.01"
					},
					{
						label: "1.0升以上至1.5升(含)的乘用车",
						value: "101020902",
						type: "1",
						shuil: "0.03"
					},
					{
						label: "1.5升以上至2.0升(含)的乘用车",
						value: "101020903",
						type: "1",
						shuil: "0.05"
					},
					{
						label: "2.0升以上至2.5升(含)的乘用车",
						value: "101020904",
						type: "1",
						shuil: "0.09"
					},
					{
						label: "2.5升以上至3.0升(含)的乘用车",
						value: "101020905",
						type: "1",
						shuil: "0.12"
					},
					{
						label: "3.0升以上至4.0升(含)的乘用车",
						value: "101020906",
						type: "1",
						shuil: "0.25"
					},
					{
						label: "4.0升以上的乘用车",
						value: "101020907",
						type: "1",
						shuil: "0.40"
					},

				]
			},
			{
				label: "中轻型商用客车",
				value: "101021000",
				type: "1",
				shuil: "0.05"
			},
			{
				label: "高尔夫球及球具",
				value: "101021100",
				type: "1",
				shuil: "0.10"
			},
			{
				label: "高档手表",
				value: "101021200",
				type: "1",
				shuil: "0.20"
			},
			{
				label: "游艇",
				value: "101021300",
				type: "1",
				shuil: "0.10"
			},
			{
				label: "木制一次性筷子",
				value: "101021400",
				type: "1",
				shuil: "0.05"
			},
			{
				label: "实木地板",
				value: "101021500",
				type: "1",
				shuil: "0.05"
			},
			{
				label: "电池",
				value: "101021600",
				children: [{
						label: "电池（不含铅蓄电池）",
						value: "101021601",
						type: "1",
						shuil: "0.04"
					}, {
						label: "铅蓄电池",
						value: "101021699",
						type: "1",
						shuil: "0.04"
					},

				]
			},
			{
				label: "涂料",
				value: "101021700",
				type: "1",
				shuil: "0.04"
			},
			{
				label: "高档化妆品",
				value: "101021800",
				type: "1",
				shuil: "0.15"
			},
			{
				label: "超豪华小汽车",
				value: "101021900",
				children: [{
					label: "超豪华乘用车",
					value: "101021901",
					type: "1",
					shuil: "0.10"
				}, {
					label: "超豪华中轻型商用客车",
					value: "101021902",
					type: "1",
					shuil: "0.05"
				}]
			},
		]
	}
	return obj
}